import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import DropdownForAlertingMatrix from "./DropdownForAlertingMatrix";
import InputField from "../../common/components/FormFields/InputField";
import CommonButton from "../../common/components/Buttons/CommonButton";
import ConfirmationModal from "../../common/components/ConfirmationModal";
import CommonDivider from "../../common/components/divider/CommonDivider";
import { getRolesAutocomplete } from "../Services/UserManagementServices";
import {
  getUsersData,
  saveAlertingMatrix,
} from "../Services/AlertingMatrixServices";
import SearchDropdown from "../../common/components/FormFields/searchDropdown";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  errorAlert,
  successAlert,
} from "../../common/components/Toasts/Toasts";

function AlertingMatrix() {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [formData, setFormData] = useState([]);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);

  const levelsArray = [
    {
      level: "Level 2",
      levelId: 2,
      bgcolor: "#FFE8DE",
    },
    {
      level: "Level 3",
      levelId: 3,
      bgcolor: "#FFFBD2",
    },
    {
      level: "Level 4",
      levelId: 4,
      bgcolor: "#FBE0FF",
    },
  ];

  const defaultValues = {
    selectRole: [],
    selectUserLevel2: [],
    selectUserLevel3: [],
    selectUserLevel4: [],
    escalateAfterLevel2: "",
    escalateAfterLevel3: "",
    escalateAfterLevel4: "",
  };

  const Schema = yup.object().shape({
    // selectRole: yup.array().min(1, "At least one role must be selected"),
    // selectUserLevel2: yup
    //   .array()
    //   .min(1, "At least one user must be selected for Level 2"),
    // selectUserLevel3: yup
    //   .array()
    //   .min(1, "At least one user must be selected for Level 3"),
    // selectUserLevel4: yup
    //   .array()
    //   .min(1, "At least one user must be selected for Level 4"),
    // escalateAfterLevel2: yup
    //   .number()
    //   .required("Escalation time is required for Level 2")
    //   .positive("Must be a positive number"),
    // escalateAfterLevel3: yup
    //   .number()
    //   .required("Escalation time is required for Level 3")
    //   .positive("Must be a positive number"),
    // escalateAfterLevel4: yup
    //   .number()
    //   .required("Escalation time is required for Level 4")
    //   .positive("Must be a positive number"),
  });

  const {
    control,
    reset,
    setValue,
    watch,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues,
    resolver: yupResolver(Schema),
  });

  const onSubmit = (data) => {
    console.log("Submitted Data: ", data);
    const tempSelectRole = [];
    data.selectRole?.forEach((elem) => {
      tempSelectRole.push({ id: elem.id });
    });

    const tempEscalateAfterLevel2 = [];
    data.selectUserLevel2?.forEach((elem) => {
      tempEscalateAfterLevel2.push({ id: elem.value });
    });

    const tempEscalateAfterLevel3 = [];
    data.selectUserLevel3?.forEach((elem) => {
      tempEscalateAfterLevel3.push({ id: elem.value });
    });

    const tempEscalateAfterLevel4 = [];
    data.selectUserLevel3?.forEach((elem) => {
      tempEscalateAfterLevel4.push({ id: elem.value });
    });

    const payload = [
      {
        level: 1,
        users: tempSelectRole,
      },
      {
        level: 2,
        users: tempEscalateAfterLevel2,
        escalateInMins: data?.escalateAfterLevel2,
      },
      {
        level: 3,
        users: tempEscalateAfterLevel3,
        escalateInMins: data?.escalateAfterLevel3,
      },
      {
        level: 4,
        users: tempEscalateAfterLevel4,
        escalateInMins: data?.escalateAfterLevel4,
      },
    ];

    console.log("payload :", payload);
    setFormData(payload);
    setOpenConfirmationModal(true);
  };

  const handleSaveAlertingMatrix = () => {
    saveAlertingMatrix(formData)
      .then((response) => response.data)
      .then((res) => {
        setOpenConfirmationModal(false);
        successAlert(res?.message);
        setOpenConfirmationModal(false);
      })
      .catch((error) => {
        errorAlert(error?.message);
      });
  };

  // useEffect(() => {
  //   const userList = [
  //     { id: 1, label: "Tushar Sawant", value: "Tushar Sawant" },
  //     { id: 2, label: "Mayur Desai", value: "Mayur Desai" },
  //     { id: 3, label: "Vishal Rawat", value: "Vishal Rawat" },
  //     { id: 4, label: "Rohit Bansode", value: "Rohit Bansode" },
  //     { id: 5, label: "Rahul Patil", value: "Rahul Patil" },
  //     { id: 6, label: "Vishal Pawar", value: "Vishal Pawar" },
  //   ];

  //   // const roleList = [
  //   //   { id: 1, label: "RMO", value: "RMO" },
  //   //   { id: 2, label: "Nurse", value: "Nurse" },
  //   // ];

  //   setUsers(userList);
  // }, []);

  React.useEffect(() => {
    // get roles autocomplete
    getRolesAutocomplete()
      .then((response) => response.data)
      .then((res) => {
        if (res.result.length > 0) {
          let roleOptions = [];
          for (let roleObject of res.result) {
            let object = {};
            object.id = roleObject.id;
            object.label = roleObject.label;
            object.value = roleObject.id;
            roleOptions.push(object);
          }
          setRoles(roleOptions);
        }
      });
  }, []);

  console.log("errors : ", errors);

  return (
    <div className="mt-16">
      <label className="flex justify-center font-semibold text-lg my-4">
        Alerting Matrix
      </label>

      <CommonDivider />
      <div className="py-3 flex justify-center w-full">
        <div className="w-full mx-3 xl:w-[75%] ">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid grid-cols-10 items-center gap-4 py-3 w-full">
              <div className="bg-[#E3F2FF] rounded-md px-4 py-2 flex justify-center items-center ">
                <p className="font-bold text-lg whitespace-nowrap">Level 1</p>
              </div>
              <div className="col-span-6 2xl:col-span-7">
                <DropdownForAlertingMatrix
                  control={control}
                  name="selectRole"
                  isSearchable={true}
                  isMulti={true}
                  searchIcon={true}
                  dataArray={roles}
                  placeholder="Select Role"
                  handleInputChange={() => {}}
                  error={errors?.selectRole}
                />
              </div>
            </div>
            <CommonDivider />
            {levelsArray.map((level, i) => {
              return (
                <div key={i} className="w-full">
                  <div className="grid grid-cols-10 items-center gap-4 mb-2 py-3  ">
                    <div
                      style={{ backgroundColor: level.bgcolor }}
                      className="rounded-md px-4 py-2 flex justify-center items-center"
                    >
                      <p className="font-bold text-lg whitespace-nowrap">
                        {level.level}
                      </p>
                    </div>
                    <div className="col-span-6 2xl:col-span-7">
                      <DropdownForAlertingMatrix
                        control={control}
                        name={`selectUserLevel${level.levelId}`}
                        // isSearchable={true}
                        isMulti={true}
                        searchIcon={true}
                        dataArray={users}
                        error={errors?.[`selectUserLevel${level.levelId}`]}
                        placeholder="Select User"
                        label="Select User"
                        handleInputChange={(val) => {
                          if (val !== "") {
                            getUsersData(val)
                              .then((response) => response.data)
                              .then((res) => {
                                if (res.statusCode === 200) {
                                  setUsers(res.result);
                                } else {
                                  setUsers([]);
                                }
                              });
                          }
                        }}
                      />
                    </div>
                    <div className="flex gap-x-3 items-center col-span-3 2xl:col-span-2">
                      <p className="whitespace-nowrap font-semibold text-sm xl:text-base">
                        Escalate After&nbsp;:
                      </p>

                      <div className="w-20 xl:w-28">
                        <InputField
                          name={`escalateAfterLevel${level.levelId}`}
                          error={errors?.[`escalateAfterLevel${level.levelId}`]}
                          label=""
                          type="number"
                          control={control}
                        />
                      </div>
                      <p>Mins</p>
                      {/* <div className="flex gap-x-2 items-center">
                        {durationOptions.map((option) => (
                          <p
                            key={option}
                            className={`rounded-full h-8 w-8 border flex justify-center items-center cursor-pointer
            ${
              watch(`durationEscalateAfterLevel${level.levelId}`) === option
                ? "bg-customBlue text-white"
                : "bg-white text-black"
            }`}
                            onClick={() =>
                              setValue(
                                `durationEscalateAfterLevel${level.levelId}`,
                                option
                              )
                            }
                          >
                            {option.charAt(0)}
                          </p>
                        ))}
                      </div> */}
                    </div>
                  </div>

                  <CommonDivider />
                </div>
              );
            })}

            <div className="flex justify-end gap-x-2 mt-4">
              <CommonButton
                type="button"
                className="border border-customRed text-customRed"
                label="Reset"
                onClick={() => reset(defaultValues)}
              />

              <CommonButton
                type="Submit"
                className="bg-customGreen text-white"
                label="Update"
              />
            </div>
          </form>
        </div>
      </div>

      {openConfirmationModal && (
        <ConfirmationModal
          confirmationOpen={openConfirmationModal}
          confirmationHandleClose={() => setOpenConfirmationModal(false)}
          confirmationSubmitFunc={handleSaveAlertingMatrix}
          confirmationMsg={"Are you sure you want to Update Alerting Matrix ?"}
          confirmationButtonMsg={"Confirm"}
          confirmationLabel={"Confirmation"}
        />
      )}
    </div>
  );
}

export default AlertingMatrix;
